<template>
  <Teleport to="body">
    <ModalWrapper
      class="modal--services directory"
      :isCollapsetoModal="true"
      @on-close-modal="$emit('onCloseModal')"
    >
      <template #header="{ ariaLabelledby }">
        <button
          type="button"
          @click="$emit('onCloseModal')"
          class="btn-close"
          aria-label="Fermer"
        >
          <i class="icon-cross-out" aria-hidden="true"></i>
        </button>
        <h1 class="modal-title" :id="ariaLabelledby">
          Les services <i class="icon icon-hospital" aria-hidden="true"></i>
        </h1>
      </template>
      <template #body>
        <template v-if="selectedMode && selectedServiceName !== 'allServices'">
          <div class="wrapper-service">
            <h2 class="service-title">{{ selectedServiceName }}</h2>
            <div>
              <h3 class="service-mode"> {{ capitalizeFirstLetter(selectedMode) }}</h3>
              <ul class="resetul list-cards-services">
                <ServiceDetails
                  v-for="(
                    serviceDetails, idx
                  ) in services.getServiceContentByNameAndMode(
                    selectedServiceName,
                    selectedMode
                  )"
                  :serviceDetails="serviceDetails"
                  :key="serviceDetails.getName() + idx"
                  :serviceName="selectedServiceName"
                />
              </ul>
            </div>
          </div>
        </template>
        <template v-else-if="selectedServiceName && selectedServiceName !== 'allServices'">
          <div class="wrapper-service">
            <h2 class="service-title">{{ selectedServiceName }}</h2>
            <div
              v-for="mode in services.getServiceContentModeListByName(
                selectedServiceName
              )"
              :key="`${ mode } ${ selectedServiceName }`"
            >
              <h3 class="service-mode">{{ capitalizeFirstLetter(mode) }}</h3>
              <ul class="resetul list-cards-services">
                <ServiceDetails
                  v-for="(
                    serviceDetails, idx
                  ) in services.getServiceContentByNameAndMode(
                    selectedServiceName,
                    mode
                  )"
                  :serviceDetails="serviceDetails"
                  :key="`${ serviceDetails.getName()} ${ idx }`"
                  :serviceName="selectedServiceName"
                />
              </ul>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="wrapper-abecedaire-cards">
            <ul class="resetul wrapper-list-services">
              <li
                v-for="serviceName in getNamesAllLetter(
                  services.getServicesNames()
                )"
                :key="serviceName"
                class="wrapper-service"
              >
                <ModalServicesContentBox
                  :serviceName="serviceName"
                  :allMode="services.getServiceContentModeListByName(serviceName)"
                  :numberService="services.getServiceNumberByName(serviceName)"
                  :anchorDisplay="serviceName === serviceNameFocus"
                />
              </li>
            </ul>
          </div>
        </template>
      </template>
    </ModalWrapper>
  </Teleport>
</template>

<script>
import {
  computed, inject, ref,
} from 'vue';
import { capitalizeFirstLetter, hashtagUrl } from '@/helpers';
import ModalWrapper from '@/components/sharedComponents/modals/ModalWrapper.component.vue';
import ServiceDetails from '@/components/phoneBook/servicesContent/servicesContentComponents/ServiceDetails.component.vue';
import ModalServicesContentBox from '@/components/phoneBook/servicesContent/servicesContentComponents/ModalServicesContentBox.component.vue';

export default {
  props: {
    what: {
      type: String,
      default: '',
    },
  },
  emit: ['onCloseModal'],
  components: {
    ModalWrapper,
    ServiceDetails,
    ModalServicesContentBox,
  },
  setup(props) {
    const selectedServiceName = inject('selectedServiceName');
    const selectedMode = inject('selectedMode');
    const services = inject('services');
    const listAlphapetAvailable = computed(() => services.value
      .getServicesNames()
      .sort()
      .map((val) => val[0]));
    const selectedLetter = ref('A');
    const serviceNameFocus = ref(props.what);
    function getNamesByLetter(servicesNames, letter) {
      return servicesNames.sort().filter((name) => name[0] === letter);
    }

    function getNamesAllLetter(servicesNames) {
      return servicesNames.sort();
    }

    if (!props.what || props.what === '') {
      const serviceName = hashtagUrl('tag');
      serviceNameFocus.value = serviceName;
    }

    return {
      listAlphapetAvailable,
      selectedLetter,
      getNamesByLetter,
      getNamesAllLetter,
      selectedServiceName,
      selectedMode,
      services,
      capitalizeFirstLetter,
      serviceNameFocus,
    };
  },
};
</script>
